import { useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import {
  ArrowIcon,
  InfoIcon
} from "../../../front-end-global-components/assets/assets";
import Button from "../../../front-end-global-components/components/Button/Button";
import CheckBox from "../../../front-end-global-components/components/CheckBox/CheckBox";
import ConditionalRender from "../../../front-end-global-components/components/ConditionalRender/ConditionalRender";
import Modal from "../../../front-end-global-components/components/Modal/Modal";
import {
  AbdmConsentHealthInfoTypes,
  consentStatus
} from "../../../utils/constants";
import { requestsValidation } from "../../../utils/requestsValidation";
import { isValidArray, isValidObject } from "../../../utils/validators";
import {
  AbdmRequestApproveSection,
  AbdmRequestDenyReasonInputSection,
  ConsentFooter,
  ConsentHeader,
  DisableAutoApproveSection,
  ProviderDetails,
  // remainingDateConversion,
  RequestSuspense,
  RevokeAccessSection
} from "./constants";
import { getPatientsUpdatedRequests } from "../../../redux/patients/actions";

export default function ConsentRequest(props) {
  const [patientsRequestData, setPatientsRequestData] = useState({});
  const [selectAllHealthLockers, setSelectAllHealthLockers] = useState(true);
  const [selectedProvidersData, setSelectedProvidersData] = useState({});
  // for future feature, set default bool is true
  const [autoApprove] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState({});
  const [checkList, setCheckList] = useState({ allProviders: true });
  const [healthLockerCheckList, setHealthLockerCheckList] = useState({
    allHealthLockers: true
  });
  const [providers, setProviders] = useState([]);
  const [healthLockersData, setHealthLockersData] = useState(null);
  const [autoApprovePoliciesData, setAutoApprovePoliciesData] = useState(null);
  // const [expireMonth, setExpireMonth] = useState(6);

  const [initialProvidersData, setInitialProvidersData] = useState({});

  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (isInitialized) return;
    if (!providers.length || !Object.keys(selectedProvidersData).length) return;

    const all = { allProviders: true };

    providers.forEach((p) => {
      const id = p.hip.id;
      const contexts = selectedProvidersData[id]?.selectedCareContexts || [];

      if (contexts.length > 0) {
        all[id] = true;
      }
    });

    setCheckList(all);
    setIsInitialized(true);
    // eslint-disable-next-line
  }, [providers, selectedProvidersData]);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.includes("/providersModal")) {
      navigate(`/abdm/consent/${props.abdmRequestId}`);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!isValidArray(providers)) {
      return;
    }

    const healthLockers = {};

    providers.forEach((data) => {
      if (data.hip.type === "HEALTH_LOCKER") {
        healthLockers[data.hip] = data;
      }
    });

    if (isValidObject(healthLockers)) {
      setHealthLockersData(Object.values(healthLockers));
    }
  }, [providers]);

  // store careContexts data in state
  useEffect(() => {
    const { currentProfile, careContexts } = props.patients;
    if (
      currentProfile &&
      careContexts &&
      isValidObject(careContexts?.[currentProfile])
    ) {
      setProviders(Object.values(careContexts?.[currentProfile]).flat());
    } else {
      setProviders([]);
    }
    // eslint-disable-next-line
  }, [props.patients.currentProfile, props.patients.careContexts]);

  useEffect(() => {
    if (patientsRequestData?.status === consentStatus?.approved) {
      getPatientsUpdatedRequests({
        type: "consent",
        id: props.abdmRequestId
      });
    }
  }, [patientsRequestData?.status, props.abdmRequestId]);

  // find request data and store in state
  useEffect(() => {
    const { currentProfile, requests, autoApprovalPolicies } = props.patients;

    if (
      !(
        props.abdmRequestId &&
        currentProfile &&
        requests &&
        isValidObject(requests?.[currentProfile]) &&
        isValidArray(requests?.[currentProfile]?.[`${props.abdmRequestType}s`])
      )
    ) {
      return;
    }

    const validatedRequests = requestsValidation(
      requests?.[currentProfile],
      autoApprovalPolicies
    )?.[`${props.abdmRequestType}s`];

    const foundRequest = validatedRequests.find(
      (request) => request.requestId === props.abdmRequestId
    );
    setPatientsRequestData(foundRequest);
    // eslint-disable-next-line
  }, [
    props.abdmRequestId,
    props.abdmRequestType,
    props.patients.requests,
    props.patients.currentProfile,
    props.patients.autoApprovalPolicies
  ]);

  useEffect(() => {
    if (!initialProvidersData || !providers.length) return;

    setCheckList((prev) => {
      if (prev?.allProviders) return prev;

      const initialCheckList = {};

      providers.forEach((provider) => {
        const id = provider.hip.id;

        if (
          isSameProviderData(
            initialProvidersData[id],
            selectedProvidersData[id]
          )
        ) {
          initialCheckList[id] = true;
        }
      });

      return initialCheckList;
    });
    // eslint-disable-next-line
  }, [initialProvidersData]);

  useEffect(() => {
    if (!checkList?.allProviders) return;

    const isAllSame = providers.every((provider) => {
      const id = provider.hip.id;

      const initial = initialProvidersData[id];
      const current = selectedProvidersData[id];

      if (!initial || !current) return true;

      return (
        initial.from === current.from &&
        initial.to === current.to &&
        initial.dataEraseAt === current.dataEraseAt &&
        JSON.stringify(initial.selectedCareContexts || []) ===
          JSON.stringify(current.selectedCareContexts || [])
      );
    });

    if (!isAllSame) {
      setCheckList((prev) => {
        const updated = { ...prev };
        delete updated.allProviders;
        return updated;
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProvidersData, providers, initialProvidersData]);

  console.log(
    patientsRequestData,
    props.patients.careContexts?.[props.patients.currentProfile],
    "test datat"
  );

  // store selected provider data in store
  useEffect(() => {
    console.log(patientsRequestData, "patientsRequestData");
    if (!patientsRequestData?.permission) {
      return;
    }
    const { dateRange, dataEraseAt } = patientsRequestData?.permission;
    const base = {
      allProviders: {
        from: dateRange?.from,
        to: dateRange?.to,
        dataEraseAt,
        selectedCareContexts: props.patients.careContexts?.[
          props.patients.currentProfile
        ]?.[patientsRequestData?.hip?.id]?.map(
          (context) => context.careContexts[0]?.referenceNumber
        ),
        requestToAccess: AbdmConsentHealthInfoTypes
      },
      allHealthLockers: {
        from: dateRange?.from,
        to: dateRange?.to,
        dataEraseAt,
        selectedCareContexts: props.patients.careContexts?.[
          props.patients.currentProfile
        ]?.[providers?.[0]?.hip?.id]?.map(
          (context) => context.careContexts[0]?.referenceNumber
        ),
        requestToAccess: AbdmConsentHealthInfoTypes
      }
    };
    console.log(
      props.patients.careContexts?.[props.patients.currentProfile],
      providers,
      "providers"
    );
    const providerEntries = providers.reduce((acc, provider) => {
      acc[provider.hip.id] = {
        from: dateRange?.from,
        to: dateRange?.to,
        dataEraseAt,
        selectedCareContexts: props.patients.careContexts?.[
          props.patients.currentProfile
        ]?.[provider.hip.id]?.map(
          (context) => context.careContexts[0]?.referenceNumber
        ),
        requestToAccess: AbdmConsentHealthInfoTypes
      };
      return acc;
    }, {});

    const finalData = {
      ...base,
      ...providerEntries
    };

    setSelectedProvidersData((prev) => {
      if (!Object.keys(prev).length) return finalData;
      return prev;
    });

    // ALWAYS update initial data when source changes
    setInitialProvidersData(finalData);
  }, [
    providers,
    patientsRequestData,
    props.patients.careContexts,
    props.patients.currentProfile
  ]);

  console.log(selectedProvidersData, "selectedProvidersData");

  function isSameProviderData(initial, current) {
    if (!initial || !current) return true;

    if (
      initial.from !== current.from ||
      initial.to !== current.to ||
      initial.dataEraseAt !== current.dataEraseAt
    ) {
      return false;
    }

    const initialContexts = initial.selectedCareContexts || [];
    const currentContexts = current.selectedCareContexts || [];

    if (initialContexts.length !== currentContexts.length) return false;

    return initialContexts.every((ctx) => currentContexts.includes(ctx));
  }

  function isCareContextSame(initial, current) {
    const a = [...(initial?.selectedCareContexts || [])].sort();
    const b = [...(current?.selectedCareContexts || [])].sort();

    return JSON.stringify(a) === JSON.stringify(b);
  }

  useEffect(() => {
    if (!checkList?.allProviders) return;

    const isAnyCareContextChanged = providers.some((provider) => {
      const id = provider.hip.id;

      return !isCareContextSame(
        initialProvidersData[id],
        selectedProvidersData[id]
      );
    });

    if (isAnyCareContextChanged) {
      setCheckList((prev) => {
        const updated = { ...prev };
        delete updated.allProviders;
        return updated;
      });
    }
    // eslint-disable-next-line
  }, [selectedProvidersData, providers, initialProvidersData]);

  useEffect(() => {
    if (!providers.length) return;

    setCheckList((prev) => {
      const updated = { ...prev };

      providers.forEach((provider) => {
        const id = provider.hip.id;
        const contexts = selectedProvidersData[id]?.selectedCareContexts || [];

        if (!contexts.length) {
          delete updated[id];
        }
      });

      return updated;
    });
  }, [selectedProvidersData, providers]);

  function approveOnClick() {
    let providersApproveData = {};
    let healthLockerApproveData = {};
    if (!checkList) {
      return;
    }

    if (patientsRequestData?.hip?.id) {
      providersApproveData = {
        [patientsRequestData.hip.id]:
          selectedProvidersData[patientsRequestData.hip.id]
      };
    } else {
      Object.keys(checkList).map((checkedId, _index) =>
        Object.keys(selectedProvidersData).forEach((selectedId) => {
          if (selectedId === checkedId) {
            providersApproveData = {
              ...providersApproveData,
              [checkedId]: selectedProvidersData[checkedId]
            };
          }
        })
      );
    }

    if (healthLockerCheckList) {
      Object.keys(healthLockerCheckList).map((checkedId, _index) =>
        Object.keys(selectedProvidersData).forEach((selectedId) => {
          if (selectedId === checkedId) {
            healthLockerApproveData = {
              ...healthLockerApproveData,
              [checkedId]: selectedProvidersData[checkedId]
            };
          }
        })
      );
    }
    props.acceptRequest(
      {
        providers: providersApproveData,
        ...(patientsRequestData?.hip?.id
          ? {}
          : { healthLockers: healthLockerApproveData })
      },
      autoApprove
    );
  }

  useEffect(() => {
    const { autoApprovalPolicies } = props.patients;
    if (!isValidObject(autoApprovalPolicies)) {
      return;
    }
    setAutoApprovePoliciesData(autoApprovalPolicies);

    // eslint-disable-next-line
  }, [props.patients.autoApprovalPolicies]);

  function changeCheckList(checked, providerId) {
    setCheckList((prev) => {
      const updated = { ...prev };

      if (checked) {
        updated[providerId] = true;

        // remove allProviders if selecting individual
        delete updated.allProviders;
      } else {
        delete updated[providerId];
      }

      return updated;
    });
  }

  function changeHealthLockerCheckList(checked, providerId) {
    if (checked) {
      setHealthLockerCheckList((prev) => ({
        ...prev,
        [providerId]: providerId
      }));
    } else {
      setHealthLockerCheckList((prev) => {
        const updated = { ...prev };
        delete updated[providerId];
        return updated;
      });
    }
  }

  const ProvidersList = (props) => {
    let providersData = [
      ...new Map(
        providers
          .flat()
          .filter((data) => data.hip.type !== "HEALTH_LOCKER")
          .map((data) => ({
            id: data.hip.id,
            name: data.hip.name
          }))
          .map((item) => [item.id, item])
      ).values()
    ];

    if (patientsRequestData?.hip?.id) {
      providersData = providersData.filter(
        (data) => data.id === patientsRequestData?.hip?.id
      );
    }

    const showProviders = props.limit
      ? providersData?.slice(0, 2)
      : providersData;

    const showHealthLockers = props.limit
      ? healthLockersData?.slice(0, 2)
      : healthLockersData;

    console.log("checkList", checkList);
    return (
      <>
        <ConditionalRender condition={props.providers}>
          {props.limit && isValidArray(providersData) && (
            <div>
              <div className="font-color-secondary font-family-gilroy-regular font-size-smaller text-transform-uppercase letter-spacing-4-percentage padding-bottom-small">
                From Providers
              </div>
              <div className="display-flex flex-align-items-center margin-bottom-large">
                {patientsRequestData?.status === consentStatus?.pending && (
                  <div className="display-flex">
                    <CheckBox
                      name="selectAllProviders"
                      id="selectAllProviders"
                      checked={!!checkList.allProviders}
                      onChange={(event) => {
                        const checked = event.target.checked;

                        if (checked) {
                          const all = { allProviders: true };
                          providers.forEach((p) => {
                            const id = p.hip.id;
                            const contexts =
                              selectedProvidersData[id]?.selectedCareContexts ||
                              [];

                            if (contexts.length > 0) {
                              all[id] = true;
                            }
                          });

                          setCheckList(all);
                          return;
                        }
                        setCheckList({});
                      }}
                    />
                  </div>
                )}
                <div
                  className="inherit-parent-width flex-justify-content-space-between flex-align-items-center"
                  onClick={() => {
                    setSelectedProvider({
                      id: "allProviders",
                      name: "All providers"
                    });
                    navigate("providersModal");
                  }}
                >
                  <div className="font-color-secondary font-family-gilroy-regular font-size-medium padding-left-default">
                    All providers
                  </div>
                  <ArrowIcon />
                </div>
              </div>
            </div>
          )}

          {isValidArray(showProviders) &&
            showProviders.map((data, index) => (
              <div
                key={index}
                className="display-flex flex-justify-content-space-between flex-align-items-center padding-bottom-large"
                data-cy="providersList"
              >
                <div className={`display-flex `}>
                  {patientsRequestData?.status === consentStatus.pending && (
                    <CheckBox
                      name={data.name}
                      id={data.name}
                      checked={
                        !!checkList[data.id] &&
                        (
                          selectedProvidersData[data.id]
                            ?.selectedCareContexts || []
                        ).length > 0
                      }
                      indeterminate={
                        (
                          selectedProvidersData[data.id]
                            ?.selectedCareContexts || []
                        ).length > 0 &&
                        !isSameProviderData(
                          initialProvidersData[data.id],
                          selectedProvidersData[data.id]
                        )
                      }
                      onChange={(event) => {
                        changeCheckList(event.target.checked, data.id);
                      }}
                    />
                  )}
                </div>
                <div
                  className="inherit-parent-width flex-justify-content-space-between flex-align-items-center"
                  onClick={() => {
                    if (!checkList[data.id]) {
                      return;
                    }

                    setSelectedProvider({
                      id: data.id,
                      name: data.name
                    });

                    navigate("providersModal");
                  }}
                >
                  <div className="font-color-secondary font-family-gilroy-regular font-size-medium padding-left-default">
                    {data.name}
                  </div>
                  <ArrowIcon />
                </div>
              </div>
            ))}

          {isValidArray(providersData) &&
            props.limit &&
            providersData.length > props.limit &&
            patientsRequestData?.status === consentStatus.pending && (
              <div className="padding-bottom-medium display-flex flex-align-items-center font-family-gilroy-medium font-color-primary">
                <div
                  onClick={() => {
                    props.moreProviderOnclick(true);
                  }}
                >
                  {`+${providersData.length - props.limit} more provider${
                    providersData.length - props.limit > 1 ? "s" : ""
                  }`}
                </div>
                <ArrowIcon color="#00A000" />
              </div>
            )}
        </ConditionalRender>

        <ConditionalRender
          condition={props.healthLockers && !patientsRequestData?.hip?.id}
        >
          {props.limit && isValidArray(healthLockersData) && (
            <div
              className={`${
                isValidArray(providersData) ? "padding-top-large" : ""
              }`}
            >
              <div className="font-color-secondary font-family-gilroy-regular font-size-smaller text-transform-uppercase letter-spacing-4-percentage padding-bottom-small">
                Health lockers
              </div>

              <div className="display-flex flex-align-items-center margin-bottom-large">
                {patientsRequestData?.status === consentStatus.pending && (
                  <div className="display-flex">
                    <CheckBox
                      name="selectAllHealthLockers"
                      id="selectAllHealthLockers"
                      checked={selectAllHealthLockers}
                      onChange={(event) => {
                        setSelectAllHealthLockers(event.target.checked);
                        if (event.target.checked) {
                          setHealthLockerCheckList({
                            allHealthLockers: event.target.checked
                          });
                        } else {
                          setHealthLockerCheckList({});
                        }
                      }}
                      data-cy={"selectAllHealthLockers"}
                    />
                  </div>
                )}
                <div
                  className="inherit-parent-width flex-justify-content-space-between flex-align-items-center"
                  onClick={() => {
                    setSelectedProvider({
                      id: "allHealthLockers",
                      name: "All health lockers"
                    });
                    navigate("providersModal");
                  }}
                >
                  <div className="font-color-secondary font-family-gilroy-regular font-size-medium padding-left-default">
                    All health lockers
                  </div>
                  <ArrowIcon />
                </div>
              </div>
            </div>
          )}

          {isValidArray(showHealthLockers) &&
            showHealthLockers.map((data, index) => (
              <div
                key={index}
                className="display-flex flex-justify-content-space-between flex-align-items-center padding-bottom-large"
                data-cy="healthLockerList"
              >
                <div
                  className={`display-flex ${
                    selectAllHealthLockers && "opacity-half"
                  }`}
                >
                  {patientsRequestData?.status === consentStatus.pending && (
                    <CheckBox
                      name={data.hip.name}
                      id={data.hip.name}
                      data-cy={`${data.hip.name}-checkBox`}
                      checked={
                        Object.keys(healthLockerCheckList).some(
                          (id) => id === data.hip.id
                        ) || selectAllHealthLockers
                      }
                      onChange={(event) => {
                        changeHealthLockerCheckList(
                          event.target.checked,
                          data.hip.id
                        );
                      }}
                    />
                  )}
                </div>
                <div
                  className="inherit-parent-width flex-justify-content-space-between flex-align-items-center"
                  data-cy={`${data.hip.name}-options`}
                  onClick={() => {
                    if (
                      !selectAllHealthLockers ||
                      patientsRequestData?.status === consentStatus.approved ||
                      patientsRequestData?.status === consentStatus.autoApproved
                    ) {
                      setSelectedProvider({
                        id: data.hip.id,
                        name: data.hip.name
                      });
                      navigate("providersModal");
                    }
                  }}
                >
                  <div className="font-color-secondary font-family-gilroy-regular font-size-medium padding-left-default">
                    {data.hip.name}
                  </div>

                  {patientsRequestData?.status === consentStatus.pending ? (
                    <ArrowIcon />
                  ) : (
                    <InfoIcon />
                  )}
                </div>
              </div>
            ))}
          {isValidArray(healthLockersData) &&
            props.limit &&
            healthLockersData.length > props.limit &&
            patientsRequestData?.status === consentStatus.pending && (
              <div className="padding-bottom-medium display-flex flex-align-items-center font-family-gilroy-medium font-color-primary">
                <div
                  onClick={() => {
                    props.moreHealthLockersOnClick(true);
                  }}
                >
                  {`+${healthLockersData.length - props.limit} more provider${
                    healthLockersData.length - props.limit > 1 ? "s" : ""
                  }`}
                </div>
                <ArrowIcon color="#00A000" />
              </div>
            )}
        </ConditionalRender>
      </>
    );
  };

  return (
    <>
      <ConditionalRender
        condition={
          !isValidArray(providers) ||
          !isValidObject(patientsRequestData) ||
          !Object.values(selectedProvidersData).length > 2
        }
      >
        <RequestSuspense />
      </ConditionalRender>

      <ConditionalRender
        condition={
          isValidArray(providers) &&
          isValidObject(patientsRequestData) &&
          Object.values(selectedProvidersData).length > 2
        }
      >
        <ConditionalRender
          condition={!props.moreProvider && !props.moreHealthLockers}
        >
          <section className="overflow-y-auto  padding-larger">
            <ConsentHeader
              status={patientsRequestData?.status}
              consentRequesterName={patientsRequestData?.requester?.name}
              consentRequesterSubName={patientsRequestData?.hiu?.id}
            />
            <section>
              <div className="padding-left-large padding-right-large">
                <div className="font-color-secondary font-family-gilroy-regular font-size-smaller text-transform-uppercase letter-spacing-4-percentage padding-bottom-small">
                  Purpose of request
                </div>
                <div className="font-color-secondary font-family-gilroy-regular font-size-medium padding-bottom-large">
                  {patientsRequestData?.purpose?.text}
                </div>

                {(patientsRequestData?.status === consentStatus?.expired ||
                  patientsRequestData?.status === consentStatus?.revoked ||
                  patientsRequestData?.status === consentStatus?.denied) && (
                  <div>
                    <div className="font-color-secondary font-family-gilroy-regular font-size-smaller text-transform-uppercase letter-spacing-4-percentage padding-bottom-small">
                      Information request duration
                    </div>
                    <div className="font-color-secondary font-family-gilroy-regular font-size-medium padding-bottom-large">
                      From{" "}
                      {formatDate(
                        patientsRequestData?.permission?.dateRange?.from
                      )}{" "}
                      To{" "}
                      {formatDate(
                        patientsRequestData?.permission?.dateRange?.to
                      )}
                    </div>

                    <div className="font-color-secondary font-family-gilroy-regular font-size-smaller text-transform-uppercase letter-spacing-4-percentage padding-bottom-small">
                      Information request type
                    </div>
                    {patientsRequestData.hiTypes.map((type) => (
                      <div className="font-color-secondary font-family-gilroy-regular font-size-medium padding-bottom-small">
                        {type}
                      </div>
                    ))}

                    <div className="font-color-secondary font-family-gilroy-regular font-size-smaller text-transform-uppercase letter-spacing-4-percentage padding-bottom-small padding-top-large">
                      Consent valid upto
                    </div>
                    <div className="font-color-secondary font-family-gilroy-regular font-size-medium padding-bottom-large">
                      {new Date(
                        patientsRequestData?.permission?.dataEraseAt
                      ).toLocaleString("en-IN", {
                        timeZone: "Asia/Kolkata",
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true
                      })}
                    </div>
                  </div>
                )}

                {patientsRequestData?.status === consentStatus?.pending && (
                  <ProvidersList
                    limit={2}
                    providers
                    healthLockers
                    moreProviderOnclick={(bool) => {
                      props.moreProviderOnclick(bool);
                    }}
                    moreHealthLockersOnClick={props.moreHealthLockersOnClick}
                  />
                )}

                {(patientsRequestData?.status === consentStatus?.approved ||
                  patientsRequestData?.status ===
                    consentStatus.autoApproved) && (
                  <ProvidersList providers healthLockers />
                )}
              </div>

              <ConditionalRender
                condition={
                  patientsRequestData?.status === consentStatus.autoApproved
                }
              >
                <div
                  className="margin-top-medium margin-left-large margin-right-large padding-medium border-1px-e5e5e5 border-radius-default"
                  onClick={() => {
                    navigate("disableAutoApproveModal");
                  }}
                >
                  This request was approved automatically due to an
                  auto-approval policy. To disable and manually approve future
                  consent requests{""}
                  <span className="font-color-primary"> Click here </span>
                </div>
              </ConditionalRender>
            </section>
          </section>

          <ConsentFooter
            loading={props.patients.loading}
            approveButtonDisabled={
              isValidObject(checkList) && isValidArray(providers) ? false : true
            }
            approveOnClick={() => {
              navigate("approveConsentModal");
            }}
            status={patientsRequestData?.status}
            denyOnClick={() => {
              navigate("denyConsentModal");
            }}
            revokeAccessOnClick={() => {
              navigate("revokeAccessModal");
            }}
            type={patientsRequestData?.type}
          />
        </ConditionalRender>

        <ConditionalRender condition={props.moreProvider}>
          <div className="inherit-parent-height">
            <div
              style={{
                height: "calc(100% - 80px)"
              }}
              className="padding-top-large padding-bottom-large padding-left-larger padding-right-larger overflow-scroll"
            >
              <ProvidersList providers />
            </div>
            <div className="display-flex padding-larger background-color-white position-absolute bottom-0 inherit-parent-width">
              <Button
                text="Save"
                boxShadow={false}
                className="margin-right-small"
                onClick={() => {
                  props.moreProviderOnclick(false);
                }}
              />
              <Button
                text="Back"
                boxShadow={false}
                variant="secondary"
                className="margin-left-small"
                onClick={() => {
                  props.moreProviderOnclick(false);
                }}
              />
            </div>
          </div>
        </ConditionalRender>

        <ConditionalRender condition={props.moreHealthLockers}>
          <div className="inherit-parent-height">
            <div
              style={{
                height: "calc(100% - 80px)"
              }}
              className="padding-top-large padding-bottom-large padding-left-larger padding-right-larger overflow-scroll"
            >
              <ProvidersList healthLockers />
            </div>
            <div className="display-flex padding-larger background-color-white position-absolute bottom-0 inherit-parent-width">
              <Button
                text="Save"
                boxShadow={false}
                className="margin-right-small"
                onClick={() => {
                  props.moreHealthLockersOnClick(false);
                }}
              />
              <Button
                text="Back"
                boxShadow={false}
                variant="secondary"
                className="margin-left-small"
                onClick={() => {
                  props.moreHealthLockersOnClick(false);
                }}
              />
            </div>
          </div>
        </ConditionalRender>
      </ConditionalRender>

      <Routes>
        <Route
          path="providersModal"
          element={
            <ShowModal
              element={
                <ProviderDetails
                  selectedCareContexts={
                    selectedProvidersData?.[selectedProvider?.id]
                      ?.selectedCareContexts
                  }
                  variant="consent"
                  consentRequesterName={selectedProvider?.name}
                  requesterId={selectedProvider?.id}
                  status={patientsRequestData?.status}
                  type={patientsRequestData?.type}
                  requestToAccess={
                    patientsRequestData?.hiTypes ||
                    selectedProvidersData?.[selectedProvider?.id]
                      ?.requestToAccess
                  }
                  needAccessTo={
                    props.patients.careContexts?.[
                      props.patients.currentProfile
                    ]?.[selectedProvider?.id]
                  }
                  givenAccessTo={patientsRequestData?.accessTo
                    ?.map((d) =>
                      selectedProvider?.id === d.hipId ? d.consentId : null
                    )
                    ?.filter(Boolean)}
                  from={selectedProvidersData?.[selectedProvider?.id]?.from}
                  to={selectedProvidersData?.[selectedProvider?.id]?.to}
                  expire={
                    selectedProvidersData?.[selectedProvider?.id]?.dataEraseAt
                  }
                  healthLockersData={healthLockersData}
                  onChangeCheckBox={(checked) => {
                    setSelectedProvidersData({
                      ...selectedProvidersData,
                      [selectedProvider.id]: {
                        ...selectedProvidersData[selectedProvider.id],
                        clone: checked
                      }
                    });
                  }}
                  dataClone={
                    selectedProvidersData?.[selectedProvider.id]?.clone
                  }
                  continueOnClick={(updated) => {
                    setSelectedProvidersData({
                      ...selectedProvidersData,
                      [selectedProvider.id]: {
                        ...selectedProvidersData[selectedProvider.id],
                        requestToAccess: updated.requestToAccess,
                        from: updated.from,
                        to: updated.to,
                        dataEraseAt: updated.expire,
                        selectedCareContexts: updated.selectedCareContexts
                      }
                    });
                    navigate(-1);
                  }}
                  backOnClick={() => navigate(-1)}
                />
              }
            />
          }
        />

        <Route
          path="approveConsentModal"
          element={
            <ShowModal
              element={
                <AbdmRequestApproveSection
                  loading={props.patients.loading}
                  approveOnClick={approveOnClick}
                  cancelOnClick={() => {
                    navigate(-1);
                  }}
                />
              }
            />
          }
        />

        <Route
          path="denyConsentModal"
          element={
            <ShowModal
              element={
                <AbdmRequestDenyReasonInputSection
                  loading={props.patients.loading}
                  denyOnClick={() => {
                    if (typeof props.denyRequest === "function") {
                      props.denyRequest(patientsRequestData.requestDenyReason);
                    }
                  }}
                  cancelOnClick={() => {
                    navigate(-1);
                    setPatientsRequestData({
                      ...patientsRequestData,
                      requestDenyReason: ""
                    });
                  }}
                  reasonInputOnChange={(event) => {
                    setPatientsRequestData({
                      ...patientsRequestData,
                      requestDenyReason: event.target.value
                    });
                  }}
                />
              }
            />
          }
        />

        <Route
          path="revokeAccessModal"
          element={
            <ShowModal
              element={
                <RevokeAccessSection
                  loading={props.patients.loading}
                  revokeOnClick={(pin) => {
                    props.revokePermission(pin);
                  }}
                  cancelOnClick={() => {
                    navigate(-1);
                  }}
                />
              }
            />
          }
        />

        <Route
          path="disableAutoApproveModal"
          element={
            <ShowModal
              element={
                <DisableAutoApproveSection
                  loading={props.patients.loading}
                  hospitalName={
                    patientsRequestData?.hiu?.name
                      ? patientsRequestData.hiu.name
                      : patientsRequestData?.hiu?.id
                  }
                  disableOnclick={(pin) => {
                    props.disableAutoApprove(
                      pin,
                      autoApprovePoliciesData &&
                        Object.values(autoApprovePoliciesData)
                          ?.filter((e) => {
                            return (
                              e.patient.healthId ===
                                patientsRequestData.patient.id &&
                              e.enabled === true
                            );
                          })
                          .map((e) => e.documentId),
                      patientsRequestData.requestId
                    );
                  }}
                  cancelOnClick={() => {
                    navigate(-1);
                  }}
                />
              }
            />
          }
        />
      </Routes>
    </>
  );
}

const ShowModal = (props) => {
  const navigate = useNavigate();
  return (
    <Modal
      onClose={() => {
        navigate(-1);
      }}
      canIgnore={true}
      show={true}
      position="position-fixed bottom-0 left-0 right-0"
      boxShadow="none"
      borderRadius="none"
      width="inherit-parent-width"
      background="background-transparent"
      height="height-fit-to-content"
    >
      <div className="background-white font-family-gilroy-medium user-select-none">
        <section className="max-width-588px margin-horizontal-auto">
          {props.element}
        </section>
      </div>
    </Modal>
  );
};

function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB");
}
